import * as React from "react";
import { useIntl, useSelector, statusUninit, statusLoading, statusWarning, statusFailed } from "@grandvisionhq/state";
import { useDispatchTrackErrorEvent } from "@grandvisionhq/svc-tealium/events";
import { useUpload } from "@grandvisionhq/upload";
import { useRxGlassesConfiguratorContext } from "../../../../context/context/RxGlassesConfiguratorContext.js";
import "../../../../state/state/actions.js";
import { PRESCRIPTION_STEP_UPLOAD_ERROR_ID } from "../../../../state/state/constants.js";
import "../../../../state/add-to-cart/state/add-to-cart/selectors.js";
import "../../../../state/bundles/state/bundles/selectors.js";
import "../../../../state/bundles/state/bundles/reducer.js";
import { getSelectedFrame, getPrescription, getIsPrescriptionUploadStepValid } from "../../../../state/configurator/state/configurator/selectors.js";
import "../../../../state/configurator/state/configurator/reducer.js";
import "../../../../state/products/state/products/selectors.js";
import "../../../../state/products/state/products/reducer.js";
import { PrescriptionUploadStep } from "./PrescriptionUploadStep.js";
const PrescriptionUploadStepContainer = () => {
  const { hasLabel, getLabel } = useIntl();
  const [errorMessageKey, setErrorMessageKey] = React.useState();
  const dispatchTrackError = useDispatchTrackErrorEvent();
  const { configuratorDocument } = useRxGlassesConfiguratorContext();
  const { prescriptionUploadStep } = configuratorDocument || {};
  const frame = useSelector(getSelectedFrame);
  const prescription = useSelector(getPrescription);
  const isPrescriptionUploadStepValid = useSelector(
    getIsPrescriptionUploadStepValid
  );
  const { error } = useUpload();
  const alertLabelKey = "products.glasses.prescriptionFileRadio.alert";
  React.useEffect(() => {
    if (isPrescriptionUploadStepValid) {
      setErrorMessageKey(null);
      return;
    }
    if (!error) {
      return;
    }
    setErrorMessageKey(error);
    const alertMessage = hasLabel(alertLabelKey) ? getLabel(alertLabelKey) : "";
    dispatchTrackError(
      () => Promise.resolve({
        Error_Source: "Server",
        Error_Code: "RX panel",
        Error_Details: error,
        Error_Message: alertMessage
      })
    );
  }, [error, isPrescriptionUploadStepValid, alertLabelKey, dispatchTrackError, getLabel, hasLabel]);
  const isLoading = !prescription || statusUninit(prescription) || statusLoading(prescription);
  const isFailed = !frame || statusWarning(prescription) || statusFailed(prescription);
  return /* @__PURE__ */ React.createElement(
    PrescriptionUploadStep,
    {
      description: prescriptionUploadStep?.description,
      image: prescriptionUploadStep?.image,
      isLoading,
      isFailed,
      errorMessage: errorMessageKey ? getLabel(errorMessageKey) : "",
      errorMessageId: PRESCRIPTION_STEP_UPLOAD_ERROR_ID,
      alertLabel: hasLabel(alertLabelKey) ? getLabel(alertLabelKey) : ""
    }
  );
};
export {
  PrescriptionUploadStepContainer
};
//# sourceMappingURL=PrescriptionUploadStepContainer.js.map
